export function isBetweenDate(date: Date, start: Date, end: Date) {
  const workDate = new Date(date).setHours(0, 0, 0, 0)
  const workStart = new Date(start).setHours(0, 0, 0, 0)
  const workEnd = new Date(end).setHours(0, 0, 0, 0)

  return workStart <= workDate && workDate <= workEnd
}

export function isBetween(date: Date, start: Date, end: Date) {
  const workDate = new Date(date).getTime()
  const workStart = new Date(start).getTime()
  const workEnd = new Date(end).getTime()

  return workStart <= workDate && workDate <= workEnd
}

export function getPrevDateByDay(date: Date, day = 'sunday') {
  const today = new Date(date)
  switch (day) {
    case 'sunday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 7) % 7)))
    case 'monday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 6) % 7)))
    case 'tuesday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 5) % 7)))
    case 'wednesday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 4) % 7)))
    case 'thursday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 3) % 7)))
    case 'friday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 2) % 7)))
    case 'saturday':
      return new Date(today.setDate(today.getDate() - ((today.getDay() + 1) % 7)))
    default:
      throw new Error('Invalid day')
  }
}

export const roundMinutes = (date: Date, minutes: number) => {
  const microseconds = 1000 * 60 * minutes
  return new Date(Math.round(date.getTime() / microseconds) * microseconds)
}
